import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CheckIcon from '../../../../../assets/icons/check.svg';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, payment, program} = contexts;

  const data: EventData = {};

  if (payment) {
    data.avatar = program?.avatar;
    data.avatarPlaceholder = program?.title;

    data.subAvatar = actor?.avatar;
    data.subAvatarPlaceholder = actor?.name;

    data.title = i18n.t('notifications:payment_marked_paid.title', {
      actorName: actor?.name,
      courseTitle: program?.title,
      price: getPriceString({
        currency: Currency[payment.currency],
        price: payment.amount,
      }),
    });
  }

  data.icon = CheckIcon;
  data.iconGradient = 'success';

  return data;
};
